import { Pipe, PipeTransform } from '@angular/core';
import { TIMEZONE_FLAT_LIST } from '@cf/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'timezoneName',
  standalone: true,
})
export class TimezoneNamePipe implements PipeTransform {
  transform(timezone: string, date?: string): string {
    const tz = TIMEZONE_FLAT_LIST.find((t) => t.value === timezone);

    if (tz) {
      if (date) {
        if (DateTime.fromISO(date, { zone: tz.value }).isInDST) {
          return tz.dstName ?? tz.name;
        }
        return tz.name;
      }
      if (DateTime.local({ zone: tz.value }).isInDST) {
        return tz.dstName ?? tz.name;
      }
      return tz.name;
    } else {
      return timezone;
    }
  }
}
